export default __webpack_public_path__ + "static/media/step3.7df01c10.svg";